module.exports = __webpack_public_path__ + "img/p5.7a33b519.jpg";